export const QUERY_KEYS = {
    UpdateSimpleMovement: 'update-simple-movement',
    ViewSimpleMovement: 'view-simple-movement',
}